import script from "./TressRadioInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./TressRadioInput.vue?vue&type=script&setup=true&lang=ts"

import "./TressRadioInput.vue?vue&type=style&index=0&id=2f45dfbc&lang=scss"

const __exports__ = script;

export default __exports__